import { render, staticRenderFns } from "./KriteriaSeleksi.vue?vue&type=template&id=ad9eed40&"
import script from "./KriteriaSeleksi.vue?vue&type=script&lang=js&"
export * from "./KriteriaSeleksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports